import { DOCUMENT, Injectable, Renderer2, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CreateOrderRequest } from '@portal/models/createOrderRequest';
import { BuilderInfoService, LanguageLocale } from '@portal/builder';
import { InternalizationService } from '../internalization/internalization.service';
import LangEnum = CreateOrderRequest.LangEnum;

@Injectable({
  providedIn: 'root',
})
export class LanguagesService {
  private readonly translateService = inject(TranslateService);
  private readonly internalization = inject(InternalizationService);
  private readonly builderInfoService = inject(BuilderInfoService);
  private readonly document = inject<Document>(DOCUMENT);

  getAvailableLanguages(): { locale: string; lang: LangEnum; name: string }[] {
    return [
      { locale: LanguageLocale.en, lang: LangEnum.EN, name: 'English' },
      { locale: LanguageLocale.ru, lang: LangEnum.RU, name: 'Русский' },
      { locale: LanguageLocale.fr, lang: LangEnum.FR, name: 'Français' },
      { locale: LanguageLocale.ar, lang: LangEnum.AR, name: 'العربية' },
      { locale: LanguageLocale.hi, lang: LangEnum.HI, name: 'हिंदी' },
      { locale: LanguageLocale.khr, lang: LangEnum.KM, name: 'ខ្មែរ' },
      { locale: LanguageLocale.cny, lang: LangEnum.ZH, name: '中文' },
    ].filter(l => {
      return this.builderInfoService.availableLanguages.includes(l.lang);
    });
  }

  getCurrentLanguage(): string {
    const langMaps = new Map<string, string>().set('khr', 'km').set('cny', 'zh');

    return (
      this.getAvailableLanguages().find(l => {
        return (langMaps.get(l.locale) ?? l.locale) === this.translateService.currentLang;
      })?.name ?? this.getAvailableLanguages()[0].name
    );
  }

  setLanguage(locale: string, renderer: Renderer2): void {
    this.internalization.setLanguage(locale);
    this.setBodyDirection(renderer);
  }

  private setBodyDirection(renderer: Renderer2): void {
    renderer.setAttribute(this.document.body, 'dir', this.builderInfoService.interfaceDirection);
  }
}
